'use client';

// import { Amplify } from 'aws-amplify';
// import { withAuthenticator } from '@aws-amplify/ui-react';
// import '@aws-amplify/ui-react/styles.css';
// import awsExports from '../aws-exports';

// Amplify.configure(awsExports);

// function App({ signOut, user }: any) {
//   return (
//     <>
//       <h1>Hello {user.username}</h1>
//       <button onClick={signOut}>Sign out</button>
//     </>
//   );
// }

// export default function Home() {
//   return <div>Welcome to minhistryofcloud ☁️</div>;
//   // return (
//   //   <div className="prose dark:prose-invert">
//   //     {allPages.map((page) => (
//   //       <article key={page._id}>
//   //         {/* <Link href={page.slug}> */}
//   //         <h2>{page.title}</h2>
//   //         {/* </Link> */}
//   //         {page.description && <p>{page.description}</p>}
//   //       </article>
//   //     ))}
//   //   </div>
//   // );
// }

import { allPosts } from '.contentlayer/generated';
import Link from 'next/link';
import { compareDesc, format, parseISO } from 'date-fns';
import { useEffect } from 'react';
import useLocalStorage from '@/hooks/useLocalStorage';

// import { API, Amplify, Auth } from 'aws-amplify';
// import { Predictions, AmazonAIPredictionsProvider } from '@aws-amplify/predictions';
// import awsconfig from '../aws-exports';

// Amplify.configure(awsconfig);
// Predictions.addPluggable(new AmazonAIPredictionsProvider());

// async function callApi() {
//   const user = await Auth.currentAuthenticatedUser();
//   const token = user.signInUserSession.idToken.jwtToken;
//   console.log('token: ', token);

//   const requestData = {
//     headers: {
//       Authorization: token,
//     },
//   };
//   const data = await API.get('AudioGeneratorApi', '/audio-generator', requestData);
//   console.log('data: ', data);
// }

export default function Home() {
  const posts = allPosts.sort((a, b) =>
    compareDesc(new Date(a.date || ''), new Date(b.date || ''))
  );

  const [value, setValue] = useLocalStorage('isPlaying', false);

  useEffect(() => {
    setValue(false);
  }, []);

  return (
    <div className="prose dark:prose-invert">
      {/* <button onClick={callApi}>Call API</button> */}
      {posts.map((post) => (
        <article key={post._id}>
          <Link href={post.slug}>
            <h2>{post.title}</h2>
          </Link>
          {post.description && <p>{post.description}</p>}
          <time dateTime={post.date} className="mb-2 block text-xs text-gray-600">
            {format(parseISO(post.date || ''), 'LLLL d, yyyy')}
          </time>
          <span className="mb-2 block text-xs text-gray-600">
            {post.readingTime}, {post.audioDuration} min listen
          </span>
        </article>
      ))}
    </div>
  );
}
